import React                     from 'react';
import { Theme }                 from '@material-ui/core/styles';
import UserOptionsMenu           from '../user-profile/UserOptionsMenu';
import PrimaryNavigationTabs     from './PrimaryNavigationTabs';
import MainContentNavbarAddMenu  from './MainContentNavbarAddMenu';
import SecondaryNavigationTabs   from './SecondaryNavigationTabs';
import SearchBar                 from './SearchBar';
import { makeStyles }            from '../utility/styles';
// import SettingsDialog            from '../settings/SettingsDialog';

const useNavbarStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    background: theme.palette.primary.main,
    borderLeft: `1px solid ${theme.palette.navBarSecondary.main}`,
  },
  topBar: {
    minHeight: '46px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap-reverse',
  },
  secondaryBar: {
    background: theme.palette.dialogPrimary.main,
    height: '31px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    borderTop: `1px solid ${theme.palette.navBarSecondary.main}`,
  },
  topBarLeftContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '1 1 auto',
  },
  topBarRightContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingRight: '8px',
  },
}));

export default React.memo(() => {
  const classes = useNavbarStyles();
  return (
    <div className={classes.root}>
      <div className={classes.topBar}>
        <div className={classes.topBarLeftContainer}>
          <PrimaryNavigationTabs />
        </div>
        <div className={classes.topBarRightContainer}>
          <MainContentNavbarAddMenu />
          <SearchBar />
          <UserOptionsMenu />
        </div>
      </div>
      <div className={classes.secondaryBar}>
        <SecondaryNavigationTabs />
      </div>
    </div>
  );
});
